import { IconName } from '@fortawesome/fontawesome-svg-core';

export const minQueryLength = 1;

export enum EUserType {
  SELF = 0,
  ADMIN = 1,
  CONTACT = 2,
  INACTIVE = 3,
  USER = 4,
  EXTERNAL = 5,
}

export type TUserType =
  | EUserType.SELF
  | EUserType.ADMIN
  | EUserType.CONTACT
  | EUserType.INACTIVE
  | EUserType.USER
  | EUserType.EXTERNAL;

export enum ETypeaheadFormatter {
  ID = 'id',
  IMAGE = 'image',
  TITLE = 'title',
  SUBTITLE = 'subtitle',
  ORIGINAL = 'original',
  USERTYPE = 'userType',
  UNALLOWED_BUTTONS = 'unallowedButtons',
}

export type TTypeaheadFormatter =
  | ETypeaheadFormatter.ID
  | ETypeaheadFormatter.IMAGE
  | ETypeaheadFormatter.TITLE
  | ETypeaheadFormatter.SUBTITLE
  | ETypeaheadFormatter.ORIGINAL
  | ETypeaheadFormatter.USERTYPE
  | ETypeaheadFormatter.UNALLOWED_BUTTONS;

export enum EItemButtons {
  DELETE = 'DELETE',
  EDIT = 'EDIT',
  WISHLIST = 'WISHLIST',
}

export type TItemButtons =
  | EItemButtons.DELETE
  | EItemButtons.EDIT
  | EItemButtons.WISHLIST;

export interface ITypeaheadItem {
  [ETypeaheadFormatter.ID]: string;
  [ETypeaheadFormatter.IMAGE]?: string;
  [ETypeaheadFormatter.TITLE]?: string | string[];
  [ETypeaheadFormatter.SUBTITLE]?: string | string[];
  [ETypeaheadFormatter.ORIGINAL]?: any;
  [ETypeaheadFormatter.USERTYPE]?: EUserType;
  [ETypeaheadFormatter.UNALLOWED_BUTTONS]?: EItemButtons[];
}

export interface ITypeaheadList {
  title: string;
  data: ITypeaheadItem[];
  buttons?: ITypeaheadButton[];
  onClickAction?: (...args: any[]) => void;
}

export interface ITypeaheadButton {
  type?: EItemButtons;
  icon?: IconName;
  image?: string;
  label?: string;
  className?: string;
  action?: (...args: any[]) => void;
}

export interface ITypeaheadProps {
  label: string;
  addRef: any;
  handleInputChange: any;
  handleOnBlur?: any;
  handleOnFocus?: any;
  options: ITypeaheadList[] | undefined;
  filterKeys?: string[];
  errorTrigger?: boolean;
  meta?: any;
  input?: any;
  withList?: boolean;
  maxListLength?: number;
  oldSelected?: ITypeaheadItem[];
  handleRemoveOldSelected?: (selected: ITypeaheadItem) => void;
  handleAddNewSelected?: (selectedArray: ITypeaheadItem[]) => void;
}

export interface ITypeaheadSelectedListProps {
  oldSelected: ITypeaheadItem[];
  newSelected: ITypeaheadItem[];
  removeNewSelectedFromList: (item: ITypeaheadItem) => void;
  removeOldSelectedFromList: (item: ITypeaheadItem) => void;
}

export const optionUserConfig: ITypeaheadItem = {
  id: 'id',
  image: 'userPhoto',
  title: 'nickname',
  subtitle: 'name',
};

export const optionWizardUserConfig: ITypeaheadItem = {
  id: 'id',
  image: 'photoUrl',
  title: 'nickname',
  subtitle: 'name',
};

export const optionContactConfig: ITypeaheadItem = {
  id: 'id',
  image: 'userPhoto',
  title: 'alias',
  subtitle: 'name',
};

export const optionInactiveContactConfig: ITypeaheadItem = {
  id: 'id',
  image: 'userPhoto',
  title: 'alias',
};

export const optionContactConfigFromContacts: ITypeaheadItem = {
  id: 'id',
  image: 'user.userPhoto',
  title: 'alias',
  subtitle: 'user.name',
};

export const inactiveUserConfig: ITypeaheadItem = {
  id: 'id',
  title: 'nickname',
};

export const externalUserConfig: ITypeaheadItem = {
  id: 'id',
  title: 'nickname',
};
